<template>
  <div class="container-fluid mt-2">
    <div class="d-flex flex-row">
      <div class="flex-grow-1">
        <h3>
          <fa-icon :icon="icon" />
          {{title}}
        </h3>
      </div>
      <div class="d-none d-lg-block">
        <slot />
      </div>
      <div class="d-lg-none">
        <button class="btn btn-outline-dark" @click="toggleSidebar">
          <fa-icon icon="bars" />
        </button>
      </div>
    </div>
    <hr />
  </div>
</template>
<script>
export default {
  props: {
    title: { type: String, default: "DashboardTitle" },
    icon: { type: String, default: "DashboardTitle" }
  },
  methods: {
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    }
  }
};
</script>


<style>
</style>
